import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';

interface BackButtonProps {
    onClick: () => void;
    className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick, className }) => {
    return (
        <button
            onClick={onClick}
            className={`flex items-center gap-2 px-4 py-2 text-sm rounded-md bg-gray-300 transition-all text-brown-600 border border-gray-300 hover:bg-gray-100 ${className}`}
        >
            <ArrowLeftIcon className="w-5 h-5" />
            <span>Back</span>
        </button>
    );
};

export default BackButton;
